import { render, staticRenderFns } from "./answer repiter new.vue?vue&type=template&id=6c886cae&scoped=true"
import script from "./answer repiter new.vue?vue&type=script&lang=js"
export * from "./answer repiter new.vue?vue&type=script&lang=js"
import style0 from "./answer repiter new.vue?vue&type=style&index=0&id=6c886cae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c886cae",
  null
  
)

export default component.exports